export default "__VITE_ASSET__VJIWOjfN__"